import { CreateEquipoDTO } from "@/application/dto/equipos/CreateEquipoDTO";
import { IEquipoRepository } from "@/domain/repositories/IEquipoRepository";

// application/use-cases/CreateEquipoUseCase.ts

export class CreateEquipoUseCase {

    constructor(
        private repository: IEquipoRepository
    ) {}

    async execute(data: CreateEquipoDTO) {
        
        return this.repository.create(data);
    }

}